import api from "@/lib/api";

export interface GetChangeDetailRequest {
  deviceType: string;
  gradeType: string;
  termType: string;
  contractNumber: string;
}

export interface GetChangeDetailResponse {
  currencyCode: string;
  current: object;
  changePlans: any;
  discountPrice: number;
  discountRemainMonth: number;
  discountSettlementScheduledTo: number;
  firstChangePlanType: string;
  isDiscount: boolean;
  instantPayment: number;
  isImmediateNoPriceDifference: boolean;
  regularSettlementScheduledPrice: number;
  regularSettlementScheduledFrom: number;
  settlementScheduledPrice: number;
  settlementScheduledTerm: string;
  settlementScheduledAt: number;
}

export interface PostChangePlansRequest {
  deviceType: string;
  gradeType: string;
  termType: string;
  instantPayment: number;
}

export interface PostChangePlansResponse {
  status: string;
  returnUrl: string;
}

export interface PostChangeContractCancelRequest {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export interface PostChangeContractCancelResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  getChangeDetail(data: GetChangeDetailRequest) {
    return api<GetChangeDetailRequest, GetChangeDetailResponse>({
      endpoint: "contracts/change-plans/web-api/change-detail",
      method: "GET",
      queryParams: data
    });
  },
  postChangePlans(data: PostChangePlansRequest) {
    return api<PostChangePlansRequest, PostChangePlansResponse>({
      endpoint: "contracts/change-plans/web-api/change",
      method: "POST",
      body: data
    });
  },
  postChangeContractCancel(data: PostChangeContractCancelRequest) {
    return api<
      PostChangeContractCancelRequest,
      PostChangeContractCancelResponse
    >({
      endpoint: "contracts/change-plans/web-api/cancel",
      method: "POST",
      body: data
    });
  }
};
